var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { useIsMobileContext } from "@nitra/nkmb-card-components/contexts";
import { toLongDate, toWeekdayDayAndTime } from "@nitra/nkmb-card-components/utils";
import { useTranslation } from "react-i18next";
export var CardTimestamp = function (props) {
    var brightText = props.brightText, date = props.date;
    var isMobile = useIsMobileContext();
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    return (_jsx(Typography, __assign({ variant: "bodyS", sx: {
            color: brightText ? "#FFFFFF" : "#676767",
        } }, { children: isMobile ? toLongDate(date, currentLang) : toWeekdayDayAndTime(date, currentLang) })));
};
